import React from "react";
import { Route, withRouter, Switch } from "react-router-dom";
import AppContext from "./services/appContext";
import { AuthenticatedRoute, LMRoute, ValidProfileRoute } from "./services/utils";
import BaseView from "./views/BaseView";
import LoginView from "./views/LoginView";
import NewObjectiveView from "./views/NewObjectiveView";
import EditObjectiveView from "./views/EditObjectiveView";
import ViewObjectiveView from "./views/ViewObjectiveView";
import MyObjectivesView from "./views/MyObjectivesView";
import MyPerformanceView from "./views/MyPerformanceView";
import MyTeamView from "./views/MyTeamView";
import MyTeamIndividualView from "./views/MyTeamIndividualView";
import MyOneToOnesView from "./views/MyOneToOnesView";
import NewOneToOneView from "./views/NewOneToOneView";
import ViewOneToOneView from "./views/ViewOneToOneView";
import EditOneToOneView from "./views/EditOneToOneView";
import BeginOneToOneView from "./views/BeginOneToOneView";
import InvalidRoute from "./components/InvalidRoute/InvalidRoute";
import NewCascadedObjectiveView from "./views/NewCascadedObjectiveView";
import NewReviewPrepView from "./views/NewReviewPrep";
import EditReviewPrepView from "./views/EditReviewPrepView";
import ViewReviewPrepView from "./views/ViewReviewPrepView";
import MyNotificationView from "./views/MyNotificationView";
import BeginReviewView from "./views/BeginReviewView";
import NewPdpView from "./views/NewPdpView";
import EditPdpView from "./views/EditPdpView";
import ViewPdpView from "./views/ViewPdpView";
import AboutView from "./views/AboutView";
import ViewCloseObjectives from "./views/ViewCloseObjectives";
import useAdminStore from "./stores/useAdminStore";
import HomeView from "./views/HomeView";

const isUserProfileValid = () => JSON.parse(localStorage.getItem("isUserProfileValid"));
const isLineManager = () => JSON.parse(localStorage.getItem("isLineManager"));

const Routes = () => {
  const isAdmin = useAdminStore((state) => state.isAdmin);
  return (
    <AppContext.Consumer>
      {({ authenticated }) => (
        <BaseView>
          <Switch>
            <Route exact path="/login" component={LoginView} />
            <AuthenticatedRoute
              exact
              path="/"
              component={HomeView}
              authenticated={authenticated}
              isAdmin={isAdmin}
            />
            <AuthenticatedRoute
              exact
              path="/about"
              component={AboutView}
              authenticated={authenticated}
            />
            <ValidProfileRoute
              exact
              path="/new-development-goal"
              component={NewPdpView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/edit-development-goal/:id"
              component={EditPdpView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/view-development-goal/:id"
              component={ViewPdpView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/close-objectives"
              component={ViewCloseObjectives}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/my-1-2-1s"
              component={MyOneToOnesView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/new-1-2-1"
              component={NewOneToOneView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/new-1-2-1/:year/:period"
              component={NewOneToOneView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/view-1-2-1/:id"
              component={ViewOneToOneView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/view-1-2-1/:year/:period"
              component={ViewOneToOneView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/edit-1-2-1/:id"
              component={EditOneToOneView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/new-objective"
              component={NewObjectiveView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/edit-objective/:id"
              component={EditObjectiveView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/view-objective/:id"
              component={ViewObjectiveView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/my-objectives/:defaultTab"
              component={MyObjectivesView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/my-notifications"
              component={MyNotificationView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/new-cascaded-objective"
              component={NewCascadedObjectiveView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team"
              component={MyTeamView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team/:email"
              component={MyTeamIndividualView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team/:email/:defaultTab"
              component={MyTeamIndividualView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team/:email/view-objective/:id"
              component={ViewObjectiveView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team/:email/view-development-goal/:id"
              component={ViewPdpView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team/:email/view-1-2-1/:id"
              component={ViewOneToOneView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team/:email/view-1-2-1/:year/:period"
              component={ViewOneToOneView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team/:email/begin-1-2-1/:id"
              component={BeginOneToOneView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team/:email/begin-1-2-1/:year/:period"
              component={BeginOneToOneView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />

            <LMRoute
              exact
              path="/my-team/:email/view-review-prep/:financialYear/:reviewType"
              component={ViewReviewPrepView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <LMRoute
              exact
              path="/my-team/:email/begin-review/:financialYear/:reviewType"
              component={BeginReviewView}
              authenticated={authenticated}
              isLineManager={isLineManager()}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/my-performance"
              component={MyPerformanceView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/new-review-prep/:financialYear/:reviewType"
              component={NewReviewPrepView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/edit-review-prep/:financialYear/:reviewType"
              component={EditReviewPrepView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <ValidProfileRoute
              exact
              path="/view-review-prep/:financialYear/:reviewType"
              component={ViewReviewPrepView}
              authenticated={authenticated}
              isUserProfileValid={isUserProfileValid()}
              isAdmin={isAdmin}
            />
            <Route component={InvalidRoute} />
          </Switch>
        </BaseView>
      )}
    </AppContext.Consumer>
  );
};

export default withRouter(Routes);
